<template>
    <div id="productContainer">
        <el-tabs v-model="activeName">
            <i class="el-icon-arrow-left proIco" id="proLeft" @click="proLeft"></i>
            <el-tab-pane name="1">
                <div slot="label" class="itemPro">
                    <div class="linePro"></div>
                    <div class="product-one pro-icon"></div>
                    <div class="namePro">供水管网建模</div>
                </div>
                <div class="textPro">
                    <div class="prodTitle">
                        <span>供水管网建模</span>
                    </div>
                    <div class="prodText">
                        三博的管网模型专家有着丰富的建模实践经验，为用户提供全面的模型解决方案。三博坚持“一切从用户需求出发”的理念，根据用户实际情况制定最合适的建模方案，包括模型工具选择、功能设置、现场测试方案、培训计划等，使所建立的模型能够最大限度地发挥效益。
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane name="2">
                <div slot="label" class="itemPro">
                    <div class="linePro"></div>
                    <div class="product-two pro-icon"></div>
                    <div class="namePro">长距离输水水力模型</div>
                </div>
                <div class="textPro">
                    <div class="prodTitle">
                        <span>长距离输水水力模型</span>
                    </div>
                    <div class="prodText">
                        三博的专家为国内供水企业和设计院提供长距离输水管线的瞬变流分析，实验室水力学模拟、水锤防护方案论证以及水锤保护设备选型等专业咨询服务。
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane name="3">
                <div slot="label" class="itemPro">
                    <div class="linePro"></div>
                    <div class="product-three pro-icon"></div>
                    <div class="namePro">排水管网建模</div>
                </div>
                <div class="textPro">
                    <div class="prodTitle">
                        <span>排水管网建模</span>
                    </div>
                    <div class="prodText">
                        三博的排水系统专家为国内排水企业和设计院提供有关城市排水系统规划设计以及运行管理方面的咨询服务。包括污水及排水优化总体规划研究、现有排水系统的分析与改造评估、排水系统优化运营控制、排水系统承载力评估及海绵城市综合解决方案等。
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane name="4">
                <div slot="label" class="itemPro">
                    <div class="linePro"></div>
                    <div class="product-four pro-icon"></div>
                    <div class="namePro nP">复杂工业供水管道系统管理</div>
                </div>
                <div class="textPro">
                    <div class="prodTitle">
                        <span>复杂工业供水管道系统管理</span>
                    </div>
                    <div class="prodText">
                        工业供水系统具有独立供水、供水量大和管网结构复杂等特点，对供水的安全性和经济性要求较高。三博公司的工业管网管理系统能够通过建立水力模型来分析和监控供水系统的运行状态，制定各种事故预案，有效地提高供水系统的安全性，全面提高工业供水管网系统的管理水平
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane name="5">
                <div slot="label" class="itemPro">
                    <div class="linePro"></div>
                    <div class="product-five pro-icon"></div>
                    <div class="namePro nP">供水管网系统安全评估</div>
                </div>
                <div class="textPro">
                    <div class="prodTitle">
                        <span>供水管网系统安全评估</span>
                    </div>
                    <div class="prodText">
                        模拟出供水系统中各种危险因素，识别管网的薄弱环节和可能导致事故发生的条件，提供相应的对策措施，预防控制事故的发生，制定减少和控制事故蔓延的预案，从而全方位地确保供水管网系统安全可靠地运行。
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane name="6">
                <div slot="label" class="itemPro">
                    <div class="product-six pro-icon"></div>
                    <div class="namePro nP">供水水管网系统区块化</div>
                </div>
                <div class="textPro">
                    <div class="prodTitle">
                        <span>供水管网系统区块化</span>
                    </div>
                    <div class="prodText">
                        区块化的建设，可以合理地划分供水管网的供水范围，缩短供水路径，降低水龄，提高供水水质；均衡供水压力，减小漏失量，降低产销差；实现分区计量，提高供水安全可靠性。
                    </div>
                </div>
            </el-tab-pane>
            <i class="el-icon-arrow-right proIco" id="proRight" @click="proRight"></i>
        </el-tabs>
    </div>
</template>

<script>
export default {
    name: 'Screen4',
    data() {
        return {
            activeName: "1"
        };
    },
    methods: {
        proLeft(){
            let activeNum = parseInt(this.activeName)
            if(activeNum > 1){
                this.activeName = (activeNum - 1) + '';
            }
        },
        proRight(){
           let activeNum = parseInt(this.activeName)
            if(activeNum < 6){
                this.activeName = (activeNum + 1) + '';
            }
        }
    }
}
</script>

<style scoped>
    #productContainer{
        width: 1120px;
        margin: 0 auto;
        padding-top: 40px;
        padding-bottom: 65px;
    }
    .pro-icon{
        width: 85px;
        height: 85px;
        border-radius: 20px; 
        margin: 0 auto;
    }
    .product-one{
        background: url(../../assets/imgs/home/icon/pro1-1.png);
        background-size: 100% 100%;
    }
    .product-two{
        background: url(../../assets/imgs/home/icon/pro2-1.png);
        background-size: 100% 100%;
    }
    .product-three{
        background: url(../../assets/imgs/home/icon/pro3-1.png);
        background-size: 100% 100%;
    }
    .product-four{
        background: url(../../assets/imgs/home/icon/pro4-1.png);
        background-size: 100% 100%;
    }
    .product-five{
        background: url(../../assets/imgs/home/icon/pro5-1.png);
        background-size: 100% 100%;
    }
    .product-six{
        background: url(../../assets/imgs/home/icon/pro6-1.png);
        background-size: 100% 100%;
    }
    /* 选中改变 */
    #productContainer .el-tabs__item:hover .product-one,.el-tabs__item.is-active .product-one{
        background: url(../../assets/imgs/home/icon/pro1-2.png);
        background-size: 100% 100%;
    }
    #productContainer .el-tabs__item:hover .product-two,.el-tabs__item.is-active .product-two{
        background: url(../../assets/imgs/home/icon/pro2-2.png);
        background-size: 100% 100%;
    }
    #productContainer .el-tabs__item:hover .product-three,.el-tabs__item.is-active .product-three{
        background: url(../../assets/imgs/home/icon/pro3-2.png);
        background-size: 100% 100%;
    }
    #productContainer .el-tabs__item:hover .product-four,.el-tabs__item.is-active .product-four{
        background: url(../../assets/imgs/home/icon/pro4-2.png);
        background-size: 100% 100%;
    }
    #productContainer .el-tabs__item:hover .product-five,.el-tabs__item.is-active .product-five{
        background: url(../../assets/imgs/home/icon/pro5-2.png);
        background-size: 100% 100%;
    }
    #productContainer .el-tabs__item:hover .product-six,.el-tabs__item.is-active .product-six{
        background: url(../../assets/imgs/home/icon/pro6-2.png);
        background-size: 100% 100%;
    }
    .proIco{
        color: #056af0;
        cursor: pointer;
        font-size: 38px;
        font-weight: bold;
        position: absolute;
        margin-top: 120px;
    }
    #proRight{
        right:0;
        top: 0;
    }
    #proLeft{
        left:0;
    }
    .prodTitle{
        display: flex;                      /*定位（写在父元素中）*/
        justify-content:center;           /*水平居中*/
    }
    .textPro{
        width: 960px;
        margin: 0 auto;
        font-size: 16px;
        text-indent: 32px;
        line-height: 25px;
    }
    .textPro span{
        font-size: 21px;
        font-weight: bold;
        display: inline-block;
        border-bottom: 2px solid #ddd;
        padding: 35px 10px 15px 10px;
        margin-bottom: 40px;
        text-indent:0px;
    }
    .prodText{
        height: 75px;
    }
    .linePro{
        width:2px;
        height: 110px;
        background: #e0e0e0;
        float: right;
        margin-top: 20px;
    }
    .namePro{
        font-size: 16px;
        margin-left: 63px;
        margin-top: 15px;
        width: 60px;
        height: 60px;
        line-height: 20px;
        position:absolute;
    }
    .nP{
        width: 65px !important;
    }
    
</style>
